/*
  Kiwi Ears · collection toolbar (sections/collection.liquid), 2026-10-09.

  The four menus are <details>, so they work with no JS. This adds:
  · one menu open at a time; outside click and Escape close it
  · a short GSAP reveal on the panel (skipped under reduced motion)
  · Sort: picks set the filter form's sort select and fire its change, so the
    filter script swaps results in place and keeps every active filter
  · Price: the links already ride the filter script's swap (data-cf-remove);
    here the button label and the check mark follow the pick
  · "Custom range & availability…" opens the filter panel
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-kc-way]');
  if (!root || root.__kc) return;
  root.__kc = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dds = [].slice.call(root.querySelectorAll('[data-kc-dd]'));

  function closeAll(except) {
    dds.forEach(function (d) { if (d !== except) d.open = false; });
  }
  dds.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      closeAll(d);
      var menu = d.querySelector('.kc-menu');
      if (menu && window.gsap && !reduce) {
        window.gsap.fromTo(menu, { opacity: 0, y: -6 }, { opacity: 1, y: 0, duration: 0.22, ease: 'power2.out', clearProps: 'opacity,transform' });
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-kc-dd]')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = dds.filter(function (d) { return d.open; })[0];
    if (open) { open.open = false; var s = open.querySelector('summary'); if (s) s.focus(); }
  });

  function mark(dd, opt) {
    [].slice.call(dd.querySelectorAll('.kc-opt')).forEach(function (o) { o.classList.toggle('is-on', o === opt); });
    var val = dd.querySelector('[data-kc-val]');
    if (val && opt && opt.getAttribute('data-kc-pick')) val.textContent = opt.getAttribute('data-kc-pick');
    dd.open = false;
  }

  /* sort → the filter form's select, so the swap keeps every filter */
  var sortSel = document.querySelector('[data-cf-sort]');
  root.addEventListener('click', function (e) {
    var so = e.target.closest('[data-kc-sort]');
    if (so && sortSel) {
      e.preventDefault();
      sortSel.value = so.getAttribute('data-kc-sort');
      sortSel.dispatchEvent(new Event('change', { bubbles: true }));
      mark(so.closest('[data-kc-dd]'), so);
      return;
    }
    var pr = e.target.closest('[data-cf-remove][data-kc-pick]');
    if (pr) {
      /* the filter script handles the request; mirror the pick here — and
         in the form's own price fields, which its swap leaves untouched, or
         the next sort or filter change would put the old range back */
      try {
        var q = new URL(pr.href, location.href).searchParams;
        var lo = document.querySelector('[data-cf-lo]'), hi = document.querySelector('[data-cf-hi]');
        if (lo) lo.value = q.get(lo.name) || '';
        if (hi) hi.value = q.get(hi.name) || '';
      } catch (err) {}
      var dd = pr.closest('[data-kc-dd]');
      var wasOn = pr.classList.contains('is-on');
      mark(dd, wasOn ? null : pr);
      if (wasOn) { var v = dd.querySelector('[data-kc-val]'); if (v) v.textContent = 'Any price'; }
      return;
    }
    if (e.target.closest('[data-kc-morefilters]')) {
      var t = document.querySelector('[data-cf-toggle]');
      var panel = document.querySelector('[data-cf-panel]');
      closeAll(null);
      if (t && panel && panel.hidden) t.click();
      if (panel) panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  });
})();
